<template>
  <div id="app" v-loading="uiFullScreenLoading">
    <AddChildrenToOrderDialog
      v-if="showAddChildrenToOrderDialog"
    ></AddChildrenToOrderDialog>
    <ResetPasswordDialog v-if="showForgotPasswordDialog"></ResetPasswordDialog>
    <router-view></router-view>
  </div>
</template>

<script>
import MaintenanceChecker from "@/util/maintenance";
import { mapActions, mapGetters } from "vuex";
import ResetPasswordDialog from "./modules/auth/dialogs/ForgotPasswordDialog";
import AddChildrenToOrderDialog from "./modules/shop/dialogs/AddChildrenToOrderDialog";
export default {
  name: "app",
  components: { AddChildrenToOrderDialog, ResetPasswordDialog },
  mounted() {
    // eslint-disable-next-line no-undef
    console.log(`*** App ready *** - Version: ${APP_VERSION}`);
    if (process.env.NODE_ENV === "production") {
      const onServiceUp = () => {};
      const onServiceDown = () => {
        // if nginx is reporting we're in a maintenance mode, refresh the page.
        // This will present the user with a maintenance page which auto refreshes
        // every 60 seconds. When the maintenance mode is removed, they'll
        // be taken back to the app
        console.log(
          "[App] App appears to be in maintenance mode. Refreshing browser"
        );
        window.location.reload();
      };
      const url = window.location.origin + "/maintenance-mode";
      const cMaintenanceChecker = new MaintenanceChecker(
        url,
        60,
        onServiceDown,
        onServiceUp
      );
      cMaintenanceChecker.startChecking();
    }
    if (this.userIsLoggedIn) {
      this.getUserInfo();
    }
  },
  computed: {
    ...mapGetters([
      "userIsLoggedIn",
      "uiFullScreenLoading",
      "showForgotPasswordDialog",
      "showAddChildrenToOrderDialog"
    ])
  },
  methods: {
    ...mapActions(["me", "logout"]),
    getUserInfo: async function() {
      try {
        console.log("[App] Fetching user info...");
        await this.me();
      } catch (err) {
        console.warn(
          "[App] Failed to get user info on app init. Forcing user logout"
        );
        this.logout();
      }
    }
  }
};
</script>

<style lang="stylus">
@import './styles/css/general.css'
@import './styles/css/layout.css'
@import './styles/css/labels.css'
@import './styles/css/cursors.css'
@import './styles/css/mobile.css'
@import './styles/css/messages.css'
@import './styles/stylus/spacing.styl'
@import './styles/css/lib/element-ui-extends.css'
@import 'https://use.fontawesome.com/releases/v5.2.0/css/all.css'
</style>

<style lang="sass">
@import './styles/sass/products.scss'
</style>
